import { render, staticRenderFns } from "./DeleteConsumedCard.vue?vue&type=template&id=cda09880"
import script from "./DeleteConsumedCard.vue?vue&type=script&lang=js"
export * from "./DeleteConsumedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports